import styled from 'styled-components'
import { Field } from 'formik'
export const InputWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-bottom: 2rem;
`

export const InputLabel = styled.label`
  width: 100%;
  text-align: left;
  margin-bottom: 0.5rem;
  font-weight: bold;

  span {
    font-size: 0.8rem;
    opacity: 0.8;
  }
`

export const InputField = styled(Field)`
  width: 100%;
  background-color: transparent;
  border: none;
  border-bottom: solid 2px ${({ theme }) => theme.newBg3};
  padding: 0.5rem 0;
  border-radius: 0;
  outline: none;
  color: ${({ theme }) => theme.text1};

  &:hover {
    border: none;
    border-bottom: solid 2px ${({ theme }) => theme.newBg1};
  }

  &:focus {
    border: none;
    border-bottom: solid 2px ${({ theme }) => theme.newBg1};
  }

  &.error {
    border-bottom: solid 2px ${({ theme }) => theme.red2};
  }
`

export const InputDescription = styled.div`
  width: 100%;
  margin-top: 0.5rem;
  font-size: 0.9rem;
  color: ${({ theme }) => theme.text2};
`

export const InputError = styled.div`
  width: 100%;
  font-size: 0.9rem;
  margin-top: 0.5rem;
  color: ${({ theme }) => theme.red2};
`
